export const SubscriptionProcessStatus = {
    /**
     * 정기구독 프로세스 시작 요청 후 단계
     */
    /** 단순 필드 검증 완료 */
    PREPARED: 'PREPARED',
    /** 외부 유효성 검증 성공 */
    SUBSCRIPTION_PROCESS_VALIDATED: 'SUBSCRIPTION_PROCESS_VALIDATED',
    /** 외부 유효성 검증 실패 */
    VALIDATE_SUBSCRIPTION_PROCESS_FAILED: 'VALIDATE_SUBSCRIPTION_PROCESS_FAILED',
    /** 정기구독 신청 프로세스 시작됨 */
    SUBSCRIPTION_APPLICATION_STARTED: 'SUBSCRIPTION_APPLICATION_STARTED',
    /** 정기구독 신청 프로세스 시작 실패 */
    START_SUBSCRIPTION_APPLICATION_FAILED: 'START_SUBSCRIPTION_APPLICATION_FAILED',
    /**
     * 정기구독 프로세스 승인 요청 후 단계
     */
    /** 정기구독 신청 승인 검증 성공 */
    APPLY_SUBSCRIPTION_PROCESS_VALIDATED: 'APPLY_SUBSCRIPTION_PROCESS_VALIDATED',
    /** 정기구독 신청 승인 검증 실패 */
    VALIDATE_APPLY_SUBSCRIPTION_PROCESS_FAILED: 'VALIDATE_APPLY_SUBSCRIPTION_PROCESS_FAILED',
    /** 정기구독 신청 데이터 주문 db에 insert 성공 */
    SUBSCRIPTION_APPLICATION_PERSISTED: 'SUBSCRIPTION_APPLICATION_PERSISTED',
    /** 정기구독 신청 데이터 주문 db에 insert 실패 */
    PERSIST_SUBSCRIPTION_APPLICATION_FAILED: 'PERSIST_SUBSCRIPTION_APPLICATION_FAILED',
    /** 쇼핑 MY에 정기구독 신청 요청 완료 됨 */
    SUBSCRIPTION_APPLICATION_REQUESTED: 'SUBSCRIPTION_APPLICATION_REQUESTED',
    /** 쇼핑 MY에 정기구독 신청 요청 실패 됨 */
    REQUEST_SUBSCRIPTION_APPLICATION_FAILED: 'REQUEST_SUBSCRIPTION_APPLICATION_FAILED',
    /** 쇼핑 MY api timeout 발생 */
    REQUEST_SUBSCRIPTION_APPLICATION_READ_TIME_OUT_FAILED: 'REQUEST_SUBSCRIPTION_APPLICATION_READ_TIME_OUT_FAILED',
    /** 정기구독 신청 완료됨 */
    SUBSCRIPTION_APPLICATION_COMPLETED: 'SUBSCRIPTION_APPLICATION_COMPLETED',
} as const

export type SubscriptionProcessStatusValues = Constant<typeof SubscriptionProcessStatus>

export const SubscriptionProcessExceptionCode = {
    /**
     * BE에서 내려오는 에러코드
     * 이 코드 외의 코드가 내려오는 경우 SUBSCRIPTION_PROCESS_FAILED_DEFAULT 로 처리하고 있다.
     */
    /** 쇼핑 MY api timeout */
    REQUEST_SUBSCRIPTION_APPLICATION_READ_TIME_OUT: 'REQUEST_SUBSCRIPTION_APPLICATION_READ_TIME_OUT',
    /**
     * FE에서 내부적으로 정의한 에러코드
     */
    /** 정기구독 processId invalid */
    SUBSCRIPTION_PROCESS_NOT_FOUND: 'SUBSCRIPTION_PROCESS_NOT_FOUND',
    /** Exception Fail Case */
    SUBSCRIPTION_PROCESS_FAILED_DEFAULT: 'SUBSCRIPTION_PROCESS_FAILED_DEFAULT',
} as const

export type SubscriptionProcessExceptionCodeValues = Constant<typeof SubscriptionProcessExceptionCode>

/** 신청 시작 가능한 status 목록 */
export const SubscriptionPreparedStatusList: SubscriptionProcessStatusValues[] = [
    SubscriptionProcessStatus.SUBSCRIPTION_APPLICATION_STARTED,
]

/** 신청 진행중인 status 목록 */
export const SubscriptionInProgressStatusList: SubscriptionProcessStatusValues[] = [
    SubscriptionProcessStatus.APPLY_SUBSCRIPTION_PROCESS_VALIDATED,
    SubscriptionProcessStatus.SUBSCRIPTION_APPLICATION_PERSISTED,
    SubscriptionProcessStatus.PREPARED,
    SubscriptionProcessStatus.SUBSCRIPTION_PROCESS_VALIDATED,
]

/** 신청 완료 여부를 모르는 status 목록 */
export const SubscriptionCompletionUnknownStatusList: SubscriptionProcessStatusValues[] = [
    SubscriptionProcessStatus.REQUEST_SUBSCRIPTION_APPLICATION_READ_TIME_OUT_FAILED,
]

/** 신청 완료 된 status 목록 */
export const SubscriptionSuccessStatusList: SubscriptionProcessStatusValues[] = [
    SubscriptionProcessStatus.SUBSCRIPTION_APPLICATION_REQUESTED,
    SubscriptionProcessStatus.SUBSCRIPTION_APPLICATION_COMPLETED,
]
